import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { addAlert } from 'store/actions/alert/alerts';
import { authPatchRequestWithParam } from 'helpers/apiRequests';

import ThemeContext from 'components/wrapper/themeContext';
import UserSessionDataHandler from 'auth/UserSessionsDataHandler';
import { userTheme } from 'consts/config';
import DefaultComponent from './DefaultComponent';

const DefaultTheme = () => {
  const { setThemeType } = React.useContext(ThemeContext);

  const [item, setItem] = React.useState(null);

  const [defaultThemeName, setDefaultThemeName] = React.useState(
    UserSessionDataHandler.getTheme() || userTheme.light
  );
  const dispatch = useDispatch();

  const useString = () => useSelector(state => state.language);
  const alertsSubtitles = useString().alerts;

  const handleChange = event => {
    setDefaultThemeName(event.target.value);
    UserSessionDataHandler.saveToUserSettingsObjectInStorage(
      UserSessionDataHandler.defaultTheme,
      event.target.value
    );
    setThemeType(event.target.value);
    updateUserTheme(event.target.value);
  };

  const updateUserTheme = themeType => {
    const configData = UserSessionDataHandler.getUserConfig();
    const updatedUserData = {
      ...configData,
      theme: themeType,
    };
    authPatchRequestWithParam(
      'setUserConfiguration',
      UserSessionDataHandler.getUserDataObject().uid,
      { configuration: updatedUserData }
    ).then(result => {
      if (result.status !== 200)
        dispatch(
          addAlert({
            title: alertsSubtitles[result.data.code].title_,
            desc: alertsSubtitles[result.data.code].desc_,
            type: 'error',
          })
        );
    });
  };

  const subtitle = useString().userSettings.mainSettings;

  React.useEffect(() => {
    setItem({
      name: 'user-theme',
      label: 'user-theme-label',
      subtitle: subtitle.defaultTheme_,
      menu: [
        {
          key_: subtitle.defaultThemeOptions.light.key_,
          value_: userTheme.light,
        },
        {
          key_: subtitle.defaultThemeOptions.dark.key_,
          value_: userTheme.dark,
        },
      ],
    });
  }, [defaultThemeName]);

  return (
    <DefaultComponent
      item={item}
      defaultItem={defaultThemeName}
      handleChange={handleChange}
    />
  );
};

export default DefaultTheme;
